// Vite style load
import '@styles/app.scss';

import { initAccordions } from '@components-molecules/accordion';
import { initPaginator } from '@components/paginator/main';
import { initCarousel } from '@molecules/carousel';
import { initOfferCard } from '@molecules/components/offer-card';
import { initHolidayBanner } from '@molecules/holiday-banner';
import { initAdaf } from '@organisms/adaf/main';
import { initAddressDetails } from '@organisms/address-details/main';
import { initAddress } from '@organisms/address/main';
import { initBrandDetails } from '@organisms/brand-details/brand-details';
import { initDealDashboard } from '@organisms/deal-dashboard/main';
import { initFooterFull } from '@organisms/footerFull';
import { initGallery } from '@organisms/gallery';
import { initGuidedSearch } from '@organisms/guided-search/main';
import { initHome } from '@organisms/home';
import { initIdealLocationMapFilters } from '@organisms/ideal-location-map-filters';
import { initInvoice } from '@organisms/invoice/main';
import { initLeads } from '@organisms/leads/main';
import { initOfferContact } from '@organisms/offer/contact/main';
import { initSelectionItems } from '@organisms/offer/selection-items/main';
import { initStatistics } from '@organisms/offer/statistics';
import { initOfficeChooser } from '@organisms/office-chooser/main';
import { initProfileEdit } from '@organisms/organization/profile/edit';
import { initPageBrandMap } from '@organisms/page-brand/map/main';
import { initStaticGoogleMap } from '@organisms/page-details/location/main';
import { initPageSpaceContact } from '@organisms/page-space/contact/main';
import { initSpaceDetails } from '@organisms/space-details/space-details';
import { initPay } from '@organisms/ubiq-administration/main';
import { initCreateOffer } from '@pages-old/create-offer/main';
import { initEditOffer } from '@pages-old/edit-offer/main';
import { initGuide } from '@pages-old/guide';
import { initOffer } from '@pages-old/offer';
import { deviceDetect } from '@tools/device-detect';
import { lazy } from '@tools/lazyloading';
import { initIntercom } from '@elements/intercom';
import { loadAtoms } from '@atoms/load-atoms';
import { banner } from '@molecules/banner';
import { init as initFavoriteBusHandler } from '@molecules/favorite-bus-handler';
import { init as initProposalBusHandler } from '@molecules/proposal-bus-handler';
import { sliderManager } from '@molecules/slider-manager';
import { header } from '@organisms/header';
import { user } from '@organisms/user';
import { vueInit } from '@pages-old/vue-init';
import { deobfuscate } from '@organisms/deobfuscate';
import { organizationOnboarding } from '@pages-old/organization-onboarding';
import { initFavoriteButtonLoader } from '@organisms/favoriteButtonLoader';
import { nav } from './layout/nav.ts';

// Elements
deviceDetect();

// Atoms usage
lazy();
loadAtoms();

// Molecules usage
banner();
initFavoriteBusHandler();
initProposalBusHandler();
sliderManager();
user();
deobfuscate();
initAccordions();
organizationOnboarding();

// Navigation
nav();

// Organisms usage
header();
initProfileEdit();
initHome();
initGuide();
initCarousel();
initGallery();
initFooterFull();
initStatistics();
initHolidayBanner();
initOfferCard();
initOffer();
initCreateOffer();
initEditOffer();
vueInit();
initSelectionItems();
initInvoice();
initDealDashboard();
initLeads();
initPay();
initAddress();
initAddressDetails();
initAdaf();
initIdealLocationMapFilters();
initOfferContact();
initGuidedSearch();
initOfficeChooser();
initSpaceDetails();
initPageBrandMap();
initPageSpaceContact();
initStaticGoogleMap();
initBrandDetails();
initPaginator();
initFavoriteButtonLoader();
initIntercom();
